import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./index.less";
import LightningInvokeStrike from "../LightningButton/LightningInvokeStrike";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import {Spin} from "antd";
import localforage from "localforage";
import { IFeatureCollectionModel, IFeaturesModel } from "@/util/http/Lightning/responseType";
import {APIProvider, Map as GoogleMap, Marker} from "@vis.gl/react-google-maps";

import { LightningSearchTypeEnum, LightningTabsEnum } from "@/util/cosntants";

// self defined component
import RegionBoundaryPolygonOverlay from "./RegionBoundaryPolygonOverlay";
import ZoomControls from "./ZoomControls";
import DrawingControls from "./DrawingControls";
import CircleOverlay from "./CircleOverlay";
import SearchResultOverlay from "./SearchResultOverlay";
import MapLegend from "./components/MapLegends/MapLegends";
import CustomerMarker from "./components/CustomerMarker/CustomerMarker";
import ImageCarousel from "./components/ImageCarousel/ImageCarousel";
import { IDrawnShape, IPolygonShape } from "@/util/http/Lightning/requestType";
import { firstStrikeTilteArray, handleLocationSearchRequest } from "../../lightningCommonFunc";
import { updateAutoExpandParent, updateCheckedKeys, updateCommonSuccessMessage,
    updateDrawnShape,
    updateExpandedKeys,
    updateFinalRequestBoundaryCode,
    updateFinalRequestBoundaryState,
    updateIsClickedSearchResultButton,
    updateIsLoadingForDownloadImages,
    updateIsLoadingForProcessSearchResult,
    updateIsRefresh,
    updateIsResetMapContentBeforeSearch,
    updateIsStartDownloadImage,
    updateLocationNameOrCoordinate,
    updateNeedClearDrawMap,
    updateNeedClearLocation,
    updateNeedClearRegion,
    updateRadiusValue,
    updateSearchReuslt,
    updateSelectedCountry,
    updateSelectedKeys,
    updateSelectedLocationItem} from "@/redux/actions/lightningAction";
import LightingInvokeButton from "../LightningButton/LightningInvokeButton";
import html2canvas from "html2canvas";
import saveAs from "file-saver";
import JSZip from "jszip";
import ActiveKeyTimeline from "./components/ActiveKeyTimeline/ActiveKeyTimeline";

const APIKEY = "AIzaSyDlsxkoR8-fiIgncnDunmEtWEwDmr896H0";

interface IMapImage {
    key: string;
    imageUrl: string;
    title: string;
}

const LightningGoogleMap = () => {

    const mapContainerRef = useRef<HTMLDivElement>(null);

    const dispatch = useDispatch();

    const currentTab = useSelector((state: RootState) => state.lightningReducer.currentTab);
    const searchType = useSelector((state: RootState) => state.lightningReducer.searchType);
    const needClearDrawMap=useSelector((state: RootState) => state.lightningReducer?.needClearDrawMap);
    const needClearLocation=useSelector((state: RootState) => state.lightningReducer?.needClearLocation);
    const needClearRegion=useSelector((state: RootState) => state.lightningReducer?.needClearRegion);
    const isRestMapContentBeforeSearch=useSelector((state: RootState) => state.lightningReducer?.isRestMapContentBeforeSearch);

    const selectedCountry = useSelector((state: RootState) => state.lightningReducer.selectedCountry);
    const selectedFavouritesInformation = useSelector((state: RootState) => state.lightningReducer?.selectedFavouritesInfo);
    const isLoadingForGetSearchResult = useSelector((state: RootState) => state.lightningReducer.isLoadingForGetSearchResult);
    const isLoadingForGetProcessSearchResult = useSelector((state: RootState) => state.lightningReducer.isLoadingForGetProcessSearchResult);
    const isStartDownloadImage = useSelector((state: RootState) => state.lightningReducer.isStartDownloadImage);
    const isLoadingForDownloadImages = useSelector((state: RootState) => state.lightningReducer.isLoadingForDownloadImages);
    const isResetContentForCurrentTabChange = useSelector((state: RootState) => state.lightningReducer.isResetContentForCurrentTabChange);
    // for location
    const locationNameOrCoordinate = useSelector((state: RootState) => state.lightningReducer.locationNameOrCoordinate);
    const radiusValue = useSelector((state: RootState) => state.lightningReducer.radiusValue);
    const selectedLocationItem = useSelector((state: RootState) => state.lightningReducer.selectedLocationItem);
    const isGetCurrentLocation = useSelector((state: RootState) => state.lightningReducer.isGetCurrentLocation);
    // for region
    const finalRequestBoundaryState = useSelector((state: RootState) => state.lightningReducer.finalRequestBoundaryState);
    const isLoadingForGetBoundary = useSelector((state: RootState) => state.lightningReducer.isLoadingForGetBoundary);
    // for draw on map
    const drawnShape = useSelector((state: RootState) => state.lightningReducer.drawnShape);
    // for result
    const searchResult = useSelector((state: RootState) => state.lightningReducer.searchResult);
    const [groupedFeatures, setGroupedFeatures] = useState<Map<string, IFeaturesModel[]>>(new Map([]));
    const [keysToProcess, setKeysToProcess] = useState<string[]>([]);
    const [sortedTitlesToDisplay, setSortedTitlesToDisplay] = useState<string[]>([]);
    const [currentKeyIndex, setCurrentKeyIndex] = useState(-1);
    const [imagesToDownload, setImagesToDownload] = useState<IMapImage[]>([]);
    const [showCarousel, setShowCarousel] = useState(false); // 控制是否显示轮播图
    // 添加一个新状态来标记是否已完成截图流程
    const [isBatchProcessingComplete, setIsBatchProcessingComplete] = useState(false);

    const [mapHeight, setMapHeight] = useState<number>(400);
    // 地图的中心点状态
    const [center, setCenter] = useState<google.maps.LatLngLiteral>({lat: 38.0, lng: -95.0});
    const [zoom,setZoom] = useState<number>(5);
    const minZoom = 2; // 和 Map 组件的 minZoom 保持一致
    const maxZoom = 20; // 和 Map 组件的 maxZoom 保持一致
    const [latForLocationCircle, setLatForLocationCircle] = useState<number>(0);
    const [lngForLocationCircle, setLngForLocationCircle] = useState<number>(0);


    // ================== for Draw on map Favourites ==================
    useEffect(()=>{
        if(currentTab !== LightningTabsEnum.DRAWONMAP) return;
        if(selectedFavouritesInformation && selectedFavouritesInformation?.options &&
            selectedFavouritesInformation?.options?.currentTab === LightningTabsEnum.DRAWONMAP &&
            selectedFavouritesInformation?.options?.drawnShape
        ){
            const tmpDrawnShape = selectedFavouritesInformation?.options?.drawnShape as IDrawnShape;
            if(tmpDrawnShape?.type === "polygon" && tmpDrawnShape?.data && tmpDrawnShape?.data.length > 0){
                tmpDrawnShape.data.push(tmpDrawnShape?.data?.[0]); // 确保多边形闭合
            }

            // reset
            initMapCenterAndZoom();
            resetMapContent();

            dispatch(updateDrawnShape(tmpDrawnShape));
            console.log("success get drawnShape from selectedFavouritesInformation", selectedFavouritesInformation?.options?.drawnShape);
        }
    },[selectedFavouritesInformation,currentTab]);
    // ================== for Draw on map Favourites ==================

    // ================== for location center point ==================
    useEffect(()=>{
        if(currentTab !== LightningTabsEnum.LOCATION) return;
        if(radiusValue === undefined || radiusValue < 0) return;

        if(locationNameOrCoordinate){
            const [longitude,latitude]= handleLocationSearchRequest(locationNameOrCoordinate, selectedLocationItem);


            if(longitude !== 0 && latitude !== 0){
                if(longitude !== center.lng || latitude !== center.lat){
                    setCenter({ lat: latitude, lng: longitude });
                }
                setLatForLocationCircle(latitude);
                setLngForLocationCircle(longitude);
            }

            // set zoom
            let tmpZoom = zoom;
            if(radiusValue >= 80){
                tmpZoom = 9;
            }
            else if(radiusValue >= 50 && radiusValue < 80){
                tmpZoom = 10;
            }
            else if(radiusValue > 0 && radiusValue < 50){
                tmpZoom = 11;
            }

            setZoom(tmpZoom);
            resetMapContent();
        }
    },[searchType,radiusValue, selectedLocationItem, locationNameOrCoordinate]);
    // ================== for location center point ==================


    // ================== for zoom control ==================
    // 处理放大地图
    const handleZoomIn = useCallback(() => {
        setZoom(prevZoom => Math.min(prevZoom + 1, maxZoom));
    }, [maxZoom]);

    // 处理缩小地图
    const handleZoomOut = useCallback(() => {
        setZoom(prevZoom => Math.max(prevZoom - 1, minZoom));
    }, [minZoom]);

    // 监听 Map 组件自身的缩放变化，同步到 state
    const handleMapZoomChanged = useCallback((event: any) => {
        setZoom(event.detail.zoom);
    }, []);

    // 监听 Map 组件自身的中心点变化，同步到 state
    const handleMapCenterChanged = useCallback((event: any) => {
        setCenter(event.detail.center);
    }, []);
    const handleMapCenterForCurrent = useCallback((lat:number,lng:number) => {
        setCenter({lat:lat,lng:lng});
    }, []);

    // ================== for zoom control ==================



    // ================== for Draw on map ==================
    // 用于存储绘制的图形数据
    // 接收 DrawingControls 绘制完成的数据
    const handleDrawingComplete = useCallback((
        shape: IDrawnShape
    ) => {
        dispatch(updateDrawnShape(shape));
        console.log("父组件收到绘制完成事件:", shape?.type, shape?.data);
        // 你可以在这里根据 drawnShape 的数据执行其他操作，例如保存到后端
    }, []);
    // ================== for Draw on map ==================

    useEffect(()=>{
        resetMapContent();
    },[searchType,selectedCountry]);

    // ================== for Show search result ==================
    // 辅助函数：根据指定的 key (date 或 title) 分组 features
    const groupFeaturesByKey = useCallback((features: IFeaturesModel[], groupByKey: "date" | "title" | "timestamp", searchType?: string) => {
        const grouped = new Map<string, IFeaturesModel[]>();
        if(searchType === LightningSearchTypeEnum.FIRSTSTRIKE){
            firstStrikeTilteArray.forEach((firstStrikeTitle)=>{
                const tmpValue = features.filter(item=>item.properties?.title?.trim() === firstStrikeTitle);
                if(tmpValue){
                    grouped.set(firstStrikeTitle,tmpValue);
                }
                else{
                    grouped.set(firstStrikeTitle,[]);
                }
            });
            const sortedKeys = firstStrikeTilteArray;
            const sortedTitles = firstStrikeTilteArray?.map((title) => {
                const tmpTitle = title?.split("-");
                if(tmpTitle.length === 2){
                    return `${(Number(tmpTitle[0])).toFixed(0)}-${(Number(tmpTitle[1])).toFixed(0)}`;
                }
                else{
                    return title;
                }
            });
            return { grouped, sortedKeys,sortedTitles };
        }
        else{
            features.forEach(feature => {
                const key = feature.properties?.[groupByKey];
                if (key) {
                    if (!grouped.has(key)) {
                        grouped.set(key, []);
                    }
                    grouped.get(key)?.push(feature);
                }
            });
            const sortedKeys = Array.from(grouped.keys()).sort();
            const sortedTitles = sortedKeys.map((key,index)=>{
                if(groupByKey === "title"){
                    const tmpTitle = key?.split("-");
                    if(tmpTitle.length === 2){
                        return `${(Number(tmpTitle[0])).toFixed(0)}-${(Number(tmpTitle[1])).toFixed(0)}`;
                    }
                    else{
                        return key;
                    }

                }
                else{
                    return `${index * 5} - ${(index + 1) * 5}`;
                }
            });
            return { grouped, sortedKeys,sortedTitles };
        }
    }, []);

    const startBatchRenderingAndScreenshot = useCallback(async () => {
        if (!searchResult || !searchResult.features || searchResult.features.length === 0) {
            console.warn("无可渲染数据用于批量截图。");
            return;
        }
        if (!mapContainerRef.current) {
            console.error("地图容器引用不存在，无法截图。");
            return;
        }
        // if (!searchType || (searchType !== "FirstStrike" && searchType !== "Probability")) {
        //     console.warn("当前选择的类型不支持批量截图！");
        //     return;
        // }
        if(searchType && searchType === LightningSearchTypeEnum.DETECTED) return;

        // dispatch(updateIsLoadingForProcessSearchResult(true));
        setImagesToDownload([]);
        console.log("lanxue b");
        setCurrentKeyIndex(-1);

        let groupByKey: "title" | "date" | "timestamp" = searchType === "FirstStrike" ? "title" : "date";
        if(searchType === LightningSearchTypeEnum.DETECTED){
            groupByKey = "timestamp";
        }
        const { grouped, sortedKeys,sortedTitles } = groupFeaturesByKey(searchResult.features, groupByKey,searchType);

        setGroupedFeatures(grouped);
        setKeysToProcess(sortedKeys);
        setSortedTitlesToDisplay(sortedTitles);

        if (sortedKeys.length > 0) {
            if(searchType !== LightningSearchTypeEnum.FIRSTSTRIKE){
                setCurrentKeyIndex(0);
            }
            console.log(`GoogleMapComponent: 开始分批渲染和截图流程... (按 ${groupByKey} 分组)`);
        } else {
            console.log("GoogleMapComponent: 没有按指定键分组的 Features。");
            // 如果没有数据，直接显示地图，不进入轮播
            setShowCarousel(false);
        }
    }, [searchResult, groupFeaturesByKey, searchType]);

    // 自动开始分批渲染的 Effect
    useEffect(() => {
        // 增加一个条件：如果批量处理已经完成，则不再自动触发
        if (isBatchProcessingComplete) {
            console.log("批量处理已完成，阻止自动触发截图。");
            return;
        }
        if (searchResult && searchResult.features && searchResult.features.length > 0 &&
            // (searchType === "FirstStrike" || searchType === "Probability") &&
            currentKeyIndex === -1 // 确保只在未开始或已完成时自动触发
        ) {
            // 给地图一些时间来加载瓦片
            const timer = setTimeout(() => {
                startBatchRenderingAndScreenshot();
            }, 1000); // 延迟1秒，可以根据实际情况调整

            return () => clearTimeout(timer);
        }
    }, [searchResult, searchType, currentKeyIndex,isBatchProcessingComplete]); // 依赖 searchResult 和 selectedType



    useEffect(()=>{
        if(showCarousel){
            // dispatch(updateIsLoadingForProcessSearchResult(false)); // 轮播图显示时，重置加载状态
        }
    },[showCarousel]);


    // === 新增的清空所有地图内容的函数 ===
    const initMapCenterAndZoom = ()=>{
        setCenter({lat: 38.0, lng: -95.0});
        setZoom(5);
    };
    useEffect(()=>{
        if(needClearLocation || needClearRegion || needClearDrawMap){
            if(needClearLocation){
                setLatForLocationCircle(0);
                setLngForLocationCircle(0);
            }
            initMapCenterAndZoom();
            resetMapContent();
        }
    },[needClearLocation,needClearRegion,needClearDrawMap]);

    const resetMapContent = useCallback(() => {
        console.log("清空所有地图及截图相关内容...");
        dispatch(updateSearchReuslt(null)); // for search result
        setImagesToDownload([]);
        setGroupedFeatures(new Map());
        setKeysToProcess([]);
        setSortedTitlesToDisplay([]);
        setCurrentKeyIndex(-1);
        setShowCarousel(false);
        setIsBatchProcessingComplete(false);
        // if(currentTab !== LightningTabsEnum.Region){
        //     dispatch(updateSelectedCountry([]));
        // }

    }, [currentTab]);


    // === 监听 currentTab 或 selectedType 变化时调用清空函数 ===
    // 假设 `currentTab` 是一个外部传入的 prop 或者另一个 state
    // 这里以 `selectedType` 作为例子，如果你的 tab 也是一个 state，可以类似处理
    const isInitialMount = useRef(true);
    useEffect(() => {
        // 当 selectedType 变化时，触发清空操作
        // 确保不是组件初次渲染时的触发
        // 可以通过 useRef 记录是否是第一次渲染
        // if (isInitialMount.current) {
        //     isInitialMount.current = false;
        //     return; // 首次渲染不执行清空
        // }
        if(!isResetContentForCurrentTabChange) return; // 如果不需要重置内容，则直接返回

        resetMapContent();
        initMapCenterAndZoom();

        if(currentTab !== LightningTabsEnum.LOCATION){
            //For location
            // dispatch(updateNeedClearLocation(true));
            setLatForLocationCircle(0);
            setLngForLocationCircle(0);

            dispatch(updateLocationNameOrCoordinate("")); // 清空经纬度/位置
            dispatch(updateSelectedLocationItem(null)); // 清空选中项
            dispatch(updateRadiusValue(10)); // 重置半径为默认值
            dispatch(updateNeedClearLocation(false)); // 重置needClear状态
        }
        if(currentTab !== LightningTabsEnum.Region){
            //for region
            // dispatch(updateNeedClearRegion(true));
            dispatch(updateCheckedKeys([]));
            dispatch(updateSelectedKeys([]));
            dispatch(updateExpandedKeys(["United States"]));
            dispatch(updateAutoExpandParent(true));
            dispatch(updateSelectedCountry([]));
            dispatch(updateFinalRequestBoundaryState([]));
            dispatch(updateFinalRequestBoundaryCode([]));
        }
        if(currentTab !== LightningTabsEnum.DRAWONMAP){
            //for draw on map
            dispatch(updateNeedClearDrawMap(true));
        }

        dispatch(updateIsLoadingForProcessSearchResult(false)); // 重置加载状态
        dispatch(updateIsClickedSearchResultButton(false));
    // }, [currentTab, resetMapContent]); // 监听 selectedType 变化，并确保 resetMapContent 稳定
    }, [isResetContentForCurrentTabChange, resetMapContent]); // 监听 selectedType 变化，并确保 resetMapContent 稳定


    // ================== for Show search result ==================

    const handleCurrentIndex = useCallback((index: number)=>{
        setCurrentKeyIndex(index);
    },[]);
    const [isPolygonsLoading, setIsPolygonsLoading] = useState(true); // 追踪多边形是否预加载完成
    // 确保这个回调函数是稳定的
    const handleAllPolygonsLoaded = useCallback((isLoaded: boolean) => {
        console.log("所有搜索结果多边形预加载状态:", isLoaded);
        setIsPolygonsLoading(!isLoaded);
    }, []); // 依赖项如果没有任何外部状态，则为空数组


    // ================== for Show Map Legends ==================
    // 计算 MapLegend 的可见性
    // MapLegend 仅在 SearchResultOverlay 应该显示时（即有搜索结果且不显示轮播）才可见
    // 并且当前 selectedType 不为 null
    const isMapLegendVisible = useMemo(() => {
        // return searchResult !== null && searchResult?.features?.length >= 0 && searchType !== null && !showCarousel;
        return searchType !== null;
    }, [searchResult, searchType,showCarousel]);
    // ================== for Show Map Legends ==================


    // ================== for Download Images ==================
    // === 新增的状态 ===
    const [isCapturing, setIsCapturing] = useState(false); // 标识是否正在截图
    const [captureProgress, setCaptureProgress] = useState(0); // 截图进度
    // === 新增的截图逻辑 ===
    const startCapturingProcess = useCallback(() => {
        if (!mapContainerRef.current) {
            console.error("地图容器引用不存在，无法开始截图。");
            return;
        }
        if (!keysToProcess || keysToProcess.length === 0) {
            alert("没有可用于截图的数据。请先进行搜索。");
            return;
        }
        setIsCapturing(true); // 启动截图流程
        setImagesToDownload([]); // 清空之前的截图
        setCurrentKeyIndex(0); // 从第一个 key 开始截图
        setCaptureProgress(0); // 重置进度
        console.log("开始截图流程...");
    }, [keysToProcess]);
    useEffect(() => {
        const captureMap = async () => {
            if (!isCapturing || !mapContainerRef.current || keysToProcess.length === 0) {
                return;
            }
            dispatch(updateIsLoadingForDownloadImages(true)); // 开始下载图片时设置加载状态

            if (currentKeyIndex < keysToProcess.length) {
                const currentKey = keysToProcess[currentKeyIndex];
                console.log(`正在截图: ${currentKey} (${currentKeyIndex + 1}/${keysToProcess.length})`);

                // 等待地图多边形加载完成
                // 这里可能需要一个更可靠的等待机制，例如在 SearchResultOverlay 内部暴露一个 Promise
                // 或者确保 SearchResultOverlay 的渲染是同步的，且所有多边形都已加入DOM
                // 暂时使用 setTimeout 模拟等待，实际应用中可能需要调整
                await new Promise(resolve => setTimeout(resolve, 500)); // 等待多边形渲染稳定

                // 确保在截图时隐藏所有不应该出现在截图中的 UI 元素
                // 你可以通过 CSS 类名 `no-screenshot` 来实现这个目的
                // 确保 .no-screenshot 元素的 display 或 opacity 在截图前被正确设置

                // 使用 html2canvas 进行截图
                const canvas = await html2canvas(mapContainerRef.current, {
                    useCORS: true, // 允许跨域图片，如果地图瓦片是跨域的，这很重要
                    ignoreElements: (element) => {
                        // 忽略带有 'no-screenshot' 类名的元素
                        return element.classList.contains("no-screenshot");
                    }
                });

                const imageUrl = canvas.toDataURL("image/png"); // 将 canvas 转换为 base64 图片数据

                setImagesToDownload(prevImages => [
                    ...prevImages,
                    { key: currentKey, imageUrl: imageUrl, title: sortedTitlesToDisplay[currentKeyIndex] || currentKey }
                ]);

                setCaptureProgress(((currentKeyIndex + 1) / keysToProcess.length) * 100);

                // 移动到下一个 key
                setCurrentKeyIndex(prevIndex => prevIndex + 1);

            } else {
                console.log("所有截图完成。");
                // 所有截图完成后，触发下载
                downloadAllImages();
                // 重置所有状态
                resetDownload();
            }
        };

        if (isCapturing && currentKeyIndex !== -1 && !isPolygonsLoading) { // 确保多边形已加载才开始截图
            captureMap();
        }
    }, [isCapturing, currentKeyIndex, keysToProcess, sortedTitlesToDisplay, isPolygonsLoading, resetMapContent]); // 依赖项

    const resetDownload = useCallback(() => {
        console.log("清空所有地图及截图相关内容...");
        setImagesToDownload([]);
        // setGroupedFeatures(new Map());
        // setKeysToProcess([]);
        // setSortedTitlesToDisplay([]);
        setCurrentKeyIndex(0);
        setShowCarousel(false);
        setIsCapturing(false);
        dispatch(updateIsLoadingForDownloadImages(false));
        // 确保地图组件内部如果有自己的状态也需要被重置，可以通过 Key 或 Ref 调用其方法
        // 如果 GoogleMap 组件有内部状态，可能需要额外处理，例如：
        // mapInstanceRef.current?.resetView(); // 假设有这样的方法
    }, []);
    // 处理所有图片下载的函数
    const downloadAllImages = useCallback(async () => {
        if (imagesToDownload.length === 0) {
            console.log("No images to be downloaded.");
            return;
        }

        const zip = new JSZip();
        const promises: Promise<void>[] = [];

        for (const image of imagesToDownload) {
            let baseFileName: string;

            // 判断 image.key 的格式
            if (image.key.includes("/")) {
            // 看起来是日期时间格式，例如 "2025/07/04 03:00:00"
            // 将所有 "/", " ", ":" 替换为 "_"
                baseFileName = image.key
                    .replace(/\//g, "_") // 替换斜杠
                    .replace(/ /g, "_") // 替换空格
                    .replace(/:/g, "_"); // 替换冒号

            } else if (image.key.includes("-") && image.key.includes(".")) {
            // 看起来是分钟区间格式，例如 "0.00-10.00"
            // 将所有 "." 替换为 "_"，"-" 保留
                baseFileName = image.key.replace(/\./g, "_");
            } else {
            // 对于其他不符合上述模式的 key (例如，可能是纯数字ID或简单字符串)
            // 直接使用原始 key，并替换掉所有非字母数字下划线的字符以确保文件名安全
                baseFileName = image.key.replace(/[^a-zA-Z0-9_-]/g, "_");
            }

            // 拼接最终的文件名
            const fullFileName = `${baseFileName}_map_screenshot.png`;
            // 使用 fetch 获取图片数据
            // 注意：如果图片是跨域的，服务器需要设置 CORS 头部 (Access-Control-Allow-Origin)
            // 否则 fetch 会因为 CORS 策略而失败。
            // 对于非同源图片，你可能需要一个代理服务器来转发请求。
            const promise = fetch(image.imageUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Failed to fetch ${image.imageUrl}: ${response.statusText}`);
                    }
                    return response.blob(); // 以 Blob 形式获取数据
                })
                .then(blob => {
                    // 将 Blob 添加到 ZIP 文件中
                    // zip.file(`${image.key}_map_screenshot.png`, blob);
                    zip.file(`${fullFileName}`, blob);
                    console.log(`添加图片到压缩包: ${fullFileName}`);
                    // console.log(`添加图片到压缩包: ${image.key}_map_screenshot.png`);
                })
                .catch(error => {
                    console.error(`下载图片失败: ${image.imageUrl}`, error);
                    // 可以在这里处理单个图片下载失败的情况，例如跳过或记录错误
                });
            promises.push(promise);
        }

        try {
            await Promise.all(promises); // 等待所有图片都添加到 ZIP
            console.log("所有图片已添加到压缩包。");

            // 生成 ZIP 文件并下载
            const zipBlob = await zip.generateAsync({ type: "blob" });
            saveAs(zipBlob, `${searchType}.zip`); // 使用 file-saver 保存文件
            dispatch(updateCommonSuccessMessage(`All images for ${searchType} have been downloaded successfully!`));
        } catch (error) {
            console.error("打包下载图片时发生错误:", error);
        } finally {
            dispatch(updateIsStartDownloadImage(false)); // 下载完成后重置状态
        }
    }, [imagesToDownload]);

    useEffect(()=>{
        if (!isStartDownloadImage || !searchType) return;

        if(searchType === LightningSearchTypeEnum.DETECTED || searchType === LightningSearchTypeEnum.ALLCLEAR){
            html2canvas(mapContainerRef.current, {
                useCORS: true,
                allowTaint: true,
                ignoreElements: (element) => {
                    return element.classList.contains("no-screenshot");
                },
                backgroundColor: null, // 允许透明背景
            }).then((canvas) => {
                const dataUrl = canvas.toDataURL("image/png");
                console.log("test images",dataUrl);

                const link = document.createElement("a");
                link.href = dataUrl;
                link.download = searchType === LightningSearchTypeEnum.ALLCLEAR ? "Risk Zone" : searchType + ".png";
                link.click();
                // element1.style.display = "block";
            });
            dispatch(updateIsStartDownloadImage(false)); // 下载完成后重置状态
        }
        if((searchType === LightningSearchTypeEnum.PROBABILITY || searchType === LightningSearchTypeEnum.FIRSTSTRIKE)
        // && imagesToDownload && imagesToDownload.length > 0
        ){
            // 处理批量截图
            startCapturingProcess();
        }
    },[isStartDownloadImage]);
    // ================== for Download Images ==================


    const [totalHeight, setTotalHeight] = useState("calc(100vh - 400px)");
    //监听region map 上边div的高度
    const [divHeight, setDivHeight] = useState(0);
    const divRef = useRef(null);

    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            for (const entry of entries) {
                // 获取 div 的高度（包含 padding，不包含 margin）
                const height = entry.contentRect.height;
                setDivHeight(height);
            }
        });

        if (divRef.current) {
            observer.observe(divRef.current);
        }

        // 清理函数：组件卸载时停止监听
        return () => {
            if (divRef.current) {
                observer.unobserve(divRef.current);
            }
        };
    }, []);

    useEffect(()=>{
        let mapHeight;
        if (currentTab === LightningTabsEnum.Region) {
            mapHeight = 40 + divHeight;
            setTotalHeight(`calc(100vh - ${mapHeight}px)`);
            return;
        }
        if(currentTab === LightningTabsEnum.LOCATION){
            // mapHeight = 60 + (259 + 20*2) + (34 + 10*2) + 20*2 + 40 + 47;
            mapHeight = 60 + (200 + 20*2) + divHeight;
            setTotalHeight(`calc(100vh - ${mapHeight}px)`);
        }
        else if(currentTab === LightningTabsEnum.DRAWONMAP){
            // mapHeight = 60 + (200 + 20*2) + (34 + 10*2) + 20 * 2 + 40 + 47;
            mapHeight = 60 + 80;
            setTotalHeight(`calc(100vh - ${mapHeight}px)`);
        }
        // setMapHeight(mapHeight);
        // setTotalHeight(`calc(100vh - ${mapHeight}px)`);

    },[currentTab,divHeight]);

    const [loaddingToolTip,setLoadingToolTip] = useState<string>(null);
    useEffect(()=>{
        if(isLoadingForGetSearchResult){
            setLoadingToolTip("Loading search results, please wait...");
        }
        else if(isLoadingForGetProcessSearchResult){
            setLoadingToolTip("Loading search results, please wait...");
        }
        else if(isLoadingForGetBoundary){
            setLoadingToolTip("Loading region boundary, please wait...");
        }
        else if(isLoadingForDownloadImages){
            setLoadingToolTip("Downloading images, please wait...");
        }
        else{
            setLoadingToolTip(null);
        }
    },[isLoadingForGetSearchResult,isLoadingForGetProcessSearchResult,isLoadingForGetBoundary,isLoadingForDownloadImages]);

    // === 新增的切换地图类型函数 ===
    // === 新增的地图类型状态 ===
    const [mapTypeId, setMapTypeId] = useState<string>("roadmap");

    const toggleMapType = useCallback(() => {
        setMapTypeId(prevType =>
            prevType === "roadmap"
                ? "hybrid"
                : "roadmap"
        );
    }, []);

    // 使用 useMemo 缓存自定义 SVG 图标
    const customSvgIcon = useMemo(() => {
        // 检查 google 对象是否存在，避免本地开发时报错
        // if (typeof google === "undefined" || !google.maps) {
        //     return null; // 或者返回一个默认的图标配置
        // }

        return {
            path: "M 0, 0 m -6, 0 a 6, 6 0 1, 0 12, 0 a 6, 6 0 1, 0 -12, 0", // 圆形路径
            fillColor: "blue", // 填充颜色改为蓝色
            fillOpacity: 1, // 完全不透明
            strokeColor: "white", // 描边颜色为白色
            strokeWeight: 2, // 描边粗细
            scale: 1, // 缩放比例
            // anchor: new google.maps.Point(0, 0), // 锚点设为图标中心
            anchor: { x: 0, y: 0 } as google.maps.Point, // 类型断言
        };
    }, []);

    return (
        <div className="lightning-google-map" style={{ width: "100%", minHeight: "400px" }}>
            <Spin spinning={isLoadingForGetSearchResult || isLoadingForGetProcessSearchResult ||
                isLoadingForGetBoundary || isLoadingForDownloadImages
            } tip={loaddingToolTip} >
                <div ref={divRef}>
                    <LightningInvokeStrike />
                </div>

                <div className="lightning-google-map-content"
                    style={{
                        // backgroundColor:"aqua",
                        height: totalHeight,
                        minHeight: "500px",
                        position: "relative",
                        display: showCarousel ? "none" : "block" // 根据 showCarousel 隐藏或显示地图
                    }}
                    ref={mapContainerRef}
                >
                    {/* Google Map will be rendered here */}
                    <APIProvider apiKey={APIKEY} libraries={["drawing", "geometry"]}>
                        <GoogleMap
                            center={center} // 绑定中心点状态
                            zoom={zoom} // 绑定缩放级别状态
                            onZoomChanged={handleMapZoomChanged} // 监听地图自身的缩放变化
                            onCenterChanged={handleMapCenterChanged} // 监听地图自身的中心点变化
                            gestureHandling={"greedy"}
                            disableDefaultUI={true}
                            minZoom={minZoom} // 使用定义的 minZoom
                            maxZoom={maxZoom} // 使用定义的 maxZoom
                            mapTypeId={mapTypeId}
                        >
                            {/* 在地图上添加自定义标记 */}
                            {
                                currentTab === LightningTabsEnum.LOCATION && isGetCurrentLocation &&
                                (latForLocationCircle !== 0 && lngForLocationCircle !== 0) && (
                                    <Marker
                                        position={{ lat: latForLocationCircle, lng: lngForLocationCircle }} // 使用 center 状态作为标记位置
                                        icon={customSvgIcon} // 使用自定义 SVG 图标
                                        title="My Location" // 标记的提示文本
                                    />
                                )
                            }

                        </GoogleMap>

                        {/* Only show for Location */}
                        <CircleOverlay
                            lat={latForLocationCircle}
                            lng={lngForLocationCircle}
                            radiusKm={radiusValue} // 这里可以根据需要调整半径
                            searchType={searchType}
                            currentTab={currentTab} // 传递 currentTab
                            isClear = {needClearLocation}
                        />

                        {/* Only show for Region */}
                        <RegionBoundaryPolygonOverlay
                            searchType={searchType}
                            currentTab={currentTab} // 传递 currentTab
                        />

                        {/* Only show for Draw on Map */}
                        <DrawingControls
                            onDrawingComplete={handleDrawingComplete}
                            initialShape={drawnShape}
                            searchType={searchType}
                            // isMapLegendVisible={isMapLegendVisible} // 将 isMapLegendVisible 传递给 DrawingControls
                            isMapLegendVisible={false} // 将 isMapLegendVisible 传递给 DrawingControls
                            currentTab={currentTab}
                            resetMapContent={resetMapContent}
                        />

                        {/* SearchResultOverlay 只有在地图显示时才渲染 */}
                        {!showCarousel && (
                            <SearchResultOverlay
                                activeKey={keysToProcess?.[currentKeyIndex]}
                                searchType={searchType}
                                finalSearchResult={groupedFeatures}
                                onAllPolygonsLoaded={handleAllPolygonsLoaded}
                                currentKeyIndex={currentKeyIndex}
                            />
                        )}

                        {/* show CustomerMarke */}
                        <CustomerMarker
                            searchResult={searchResult}
                            searchType={searchType}
                        />
                        {/* {
                            (searchType === LightningSearchTypeEnum.DETECTED &&
                                searchResult && searchResult.features && searchResult.features.length > 0) && (
                                <CustomerMarker
                                    searchResult={searchResult}
                                    searchType={searchType}
                                />
                            )
                        } */}

                        {/* MapLegend 根据 isMapLegendVisible 状态和 selectedType 渲染 */}
                        <MapLegend
                            isVisible={isMapLegendVisible}
                            searchType={searchType} // 将当前 selectedType 传递给 MapLegend
                        />

                        {/* Always show Zoom Control */}
                        <ZoomControls
                            onZoomIn={handleZoomIn}
                            onZoomOut={handleZoomOut}
                            handleMapCenterForCurrent = {handleMapCenterForCurrent}
                            currentZoom={zoom} // 传递当前缩放级别以控制按钮禁用状态
                            minZoom={minZoom}
                            maxZoom={maxZoom}
                            toggleMapType={toggleMapType} // 新增的切换地图类型函数
                        />
                    </APIProvider>
                </div>
                {/* 底部的时间线控制器 (原轮播图控制部分) */}
                {keysToProcess.length > 1 && (
                    <div
                        // style={{ height: '80px',
                        // background: '#f8f8f8',
                        // padding: '10px', borderTop: '1px solid #eee', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <ActiveKeyTimeline
                            keysToProcess={keysToProcess}
                            // imagesData={imagesData} // 用于获取标题
                            currentTitle={sortedTitlesToDisplay?.[currentKeyIndex]}
                            initialKey={keysToProcess?.[currentKeyIndex]} // 传入当前活跃的 key，以便时间线能同步
                            onActiveKeyChange={handleCurrentIndex} // 接收时间线切换通知
                            autoplaySpeed={2000} // 设置自动播放速度
                            searchType={searchType}
                            currentKeyIndex={currentKeyIndex}
                        />
                    </div>
                )}
                {/* {
                    currentTab === LightningTabsEnum.DRAWONMAP &&
                    <div className="lightning-location-button">
                        <LightingInvokeButton />
                    </div>
                } */}
            </Spin>

        </div>
    );
};

export default LightningGoogleMap;